var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrustpilot4AndHalfStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 19,
    viewBox: "0 0 100 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.208344 0.501648H18.2083V18.5016H0.208344V0.501648Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21965 12.6747L11.9524 11.952L13.1042 15.4978L9.21965 12.6747ZM15.5208 8.09H10.6877L9.19704 3.50531L7.70647 8.09H2.87335L6.78048 10.9357L5.28991 15.5204L9.19704 12.6973L11.6137 10.9357L15.5208 8.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4583 0.501648H38.4583V18.5016H20.4583V0.501648Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4696 12.6747L32.2024 11.952L33.3542 15.4978L29.4696 12.6747ZM35.7708 8.09H30.9377L29.447 3.50531L27.9565 8.09H23.1234L27.0305 10.9357L25.5399 15.5204L29.447 12.6973L31.8636 10.9357L35.7708 8.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7083 0.501648H58.7083V18.5016H40.7083V0.501648Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7196 12.6747L52.4524 11.952L53.6042 15.4978L49.7196 12.6747ZM56.0208 8.09H51.1877L49.697 3.50531L48.2065 8.09H43.3734L47.2805 10.9357L45.7899 15.5204L49.697 12.6973L52.1136 10.9357L56.0208 8.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9583 0.501648H78.9583V18.5016H60.9583V0.501648Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9696 12.6747L72.7022 11.952L73.8542 15.4978L69.9696 12.6747ZM76.2707 8.09H71.4377L69.9471 3.50531L68.4565 8.09H63.6235L67.5306 10.9357L66.04 15.5204L69.9471 12.6973L72.3636 10.9357L76.2707 8.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2083 0.501648H99.2083V18.5016H81.2083V0.501648Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2083 0.501648H99.2083V18.5016H90.2083V0.501648Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2196 12.6747L92.9522 11.952L94.1042 15.4978L90.2196 12.6747ZM96.5207 8.09H91.6877L90.1971 3.50531L88.7065 8.09H83.8735L87.7806 10.9357L86.29 15.5204L90.1971 12.6973L92.6136 10.9357L96.5207 8.09Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 18,
    fill: "white",
    transform: "translate(0.208344 0.501648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustpilot4AndHalfStars);
export default __webpack_public_path__ + "static/media/trustpilot-4-and-half-stars.ebea16ffcff5e623ea96d65680944930.svg";
export { ForwardRef as ReactComponent };